import React from "react";
import { Card, Form, Input, Radio, Space, DatePicker } from "antd";
import { MainLayout } from "../../layouts";
import Title from "antd/lib/typography/Title";
import { useMediaQuery } from "react-responsive";
import {
  ResponsiveContainer,
  SuccessButton,
  DarkButton,
} from "../../components";

const Search: React.FC = (props) => {
  const isSm = useMediaQuery({ query: "(max-width: 640px)" });
  return (
    <MainLayout className="bg-or_gray-100" fixed={true}>
      <ResponsiveContainer>
        <Card bordered={false}>
          <Form layout="vertical" size="large">
            <Title level={3}>Deceased Ancesor Name</Title>
            <Space
              size="middle"
              direction={isSm ? "vertical" : "horizontal"}
              className="w-full sm:w-auto"
            >
              <Form.Item label="Middle Name" className="uppercase">
                <Input placeholder="Enter the middle name" />
              </Form.Item>
              <Form.Item label="Last Name" className="uppercase">
                <Input placeholder="Enter the last name" />
              </Form.Item>
            </Space>
            <Form.Item>
              <Radio.Group>
                <Radio value={1}>Male</Radio>
                <Radio value={2}>Female</Radio>
                <Radio value={3}>Unknown</Radio>
              </Radio.Group>
            </Form.Item>
            <Title level={3}>Search with life event</Title>
            <Form.Item>
              <Radio.Group defaultValue="a" buttonStyle="solid">
                <Radio.Button value="a">Birth</Radio.Button>
                <Radio.Button value="b">Mariage</Radio.Button>
                <Radio.Button value="c">Residence</Radio.Button>
                <Radio.Button value="d">Death</Radio.Button>
              </Radio.Group>
            </Form.Item>
            <Space
              size="middle"
              direction={isSm ? "vertical" : "horizontal"}
              className="w-full sm:w-auto"
            >
              <Form.Item label="Place of birth" className="uppercase">
                <Input placeholder="Enter the place of birth" />
              </Form.Item>
              <Form.Item label="Birth year (RANGE)" className="uppercase">
                <DatePicker.RangePicker />
              </Form.Item>
            </Space>
            <Form.Item>
              <Space>
                <SuccessButton size="large" className="rounded-lg">Continue</SuccessButton>
                <DarkButton size="large" className="rounded-lg">Cancel</DarkButton>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </ResponsiveContainer>
    </MainLayout>
  );
};

export default Search;
